// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__P1jfn","step-number":"Steps_step-number__x43FL","chosen-number":"Steps_chosen-number__ej-wz","not-allowed":"Steps_not-allowed__UqLox"};